import { Injectable } from '@angular/core'
import { AiResponderSettingsComponent, AiResponderSettingsTabs } from './ai-responder-settings.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { select, Store } from '@ngrx/store'
import { selectActiveProductPlanView } from '@tv3/store/plan/plan.selectors'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'
import { map, switchMap, take } from 'rxjs/operators'
import { AppOverviewDialogService } from '@tokeet-frontend/billing'

@Injectable()
export class AIResponderSettingsService {
  aiResponderSub$ = this.store.pipe(select(selectActiveProductPlanView(ProductsForPlan.TokeetAI)))

  constructor(
    private store: Store<any>,
    private dialog: DialogService,
    private appOverviewDialog: AppOverviewDialogService
  ) {}

  public open(tab?: AiResponderSettingsTabs) {
    const open = () => {
      return this.dialog
        .openDrawer(AiResponderSettingsComponent, {
          panelClass: 'drawer-full-80',
          data: { tab },
        })
        .afterClosed()
    }

    return this.aiResponderSub$.pipe(
      take(1),
      switchMap((res) => {
        if (res?.isValid) {
          return open()
        } else {
          return this.appOverviewDialog
            .open(ProductsForPlan.TokeetAI)
            .afterClosed()
            .pipe(switchMap((res) => (res === 'success' ? open() : [])))
        }
      })
    )
  }
}
